import * as React from "react";
import { useEffect, useState, useContext } from "react";
import { Button, Modal, Steps, Input, Form, Result, Space, Select } from "antd";
import { useStepsForm } from "sunflower-antd";
import type { SelectProps } from "antd";
import { AuthContext } from "../../../context/AuthContext";
import {
  getGroupsApi,
} from "../../../services/Group/GroupApis";

const { Step } = Steps;

interface IModalProps {
  show: boolean;
  showModal: Function;
  handleAdd: Function;
}

let options: SelectProps["options"] = [];

for (let i = 10; i < 36; i++) {
  options.push({
    value: i.toString(36) + i,
    label: i.toString(36) + i,
  });
}

const AddAgentModal: React.FC<IModalProps> = ({
  show,
  showModal,
  handleAdd,
}) => {
  const { currentGroup, currentUser } = useContext(AuthContext);

  const handleModal = () => {
    showModal();
    gotoStep(0);
    form.resetFields();
  };

  const fetchGroups = async () => {
    const { data } = await getGroupsApi();

    options = data.map((group: any) => {
      return {
        value: group.id,
        label: group.GroupName,
      };
    });
  };

  const {
    form,
    current,
    gotoStep,
    stepsProps,
    formProps,
    submit,
    formLoading,
  } = useStepsForm({
    isBackValidate: false,
    async submit(values) {
      const response = await handleAdd(values);

      if (response.success) {
        return true;
      }
      return false;
    },
    total: 4,
  });

  const handleChange = (value: string) => {
    console.log(`selected ${value}`);
  };

  const handleOk = () => {
    gotoStep(0);
    form.resetFields();
  };

  const handleCancel = () => {
    gotoStep(0);
    form.resetFields();
  };

  useEffect(() => {
    fetchGroups();
  }, []);

  // Step Styling
  const layout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 17 },
    labelAlign: "right" as const,
  };

  const tailLayout = {
    labelCol: { span: 6 },
    wrapperCol: { offset: 6, span: 17 },
  };

  const formList = [
    <>
      <Form.Item
        name="UserCode"
        rules={[
          {
            required: true,
          },
        ]}
      >
        <Input size="large" placeholder="User Code" />
      </Form.Item>
      <Form.Item
        name="Name"
        rules={[
          {
            required: true,
          },
        ]}
      >
        <Input size="large" placeholder="Name" />
      </Form.Item>
      <Form.Item
        name="Surname"
        rules={[
          {
            required: true,
          },
        ]}
      >
        <Input size="large" placeholder="Surname" />
      </Form.Item>

      <Form.Item
        name="Cellphone"
        rules={[
          {
            required: true,
          },
        ]}
      >
        <Input size="large" placeholder="Cellphone" />
      </Form.Item>
      <Form.Item
        name="Email"
        rules={[
          {
            required: true,
          },
        ]}
      >
        <Input size="large" placeholder="Email" />
      </Form.Item>

      <Form.Item {...tailLayout}>
        <Space direction="vertical" style={{ width: "100%" }}>
          <Button block size="large" onClick={() => gotoStep(current + 1)}>
            Next
          </Button>
        </Space>
      </Form.Item>
    </>,

    <>
      <Form.Item
        name="Group"
        rules={[
          {
            required: true,
          },
        ]}
      >
        <Select
          mode="tags"
          style={{ width: "100%" }}
          size="large"
          placeholder="Select Groups"
          onChange={handleChange}
          options={options}
        />
      </Form.Item>
      <Form.Item {...tailLayout}>
        <Space direction="vertical" style={{ width: "100%" }}>
          <Button
            style={{ marginBottom: 10 }}
            block
            size="large"
            loading={formLoading}
            onClick={() => {
              submit().then((result) => {
                if (result) {
                  gotoStep(current + 1);
                } else if (!result) {
                  gotoStep(current + 2);
                }
              });
            }}
          >
            Submit
          </Button>
        </Space>
      </Form.Item>
    </>,
  ];

  return (
    <Modal
      title="New Agent"
      open={show}
      onOk={handleModal}
      onCancel={handleModal}
      width={900}
      footer={null}
    >
      {/* Steps Form */}
      <div style={{ display: "flex", gap: 24 }}>
        {current !== 2 && (
          <div style={{ flexShrink: 0, borderRight: "1px solid #f0f0f0", paddingRight: 16, whiteSpace: "nowrap" }}>
            <Steps {...stepsProps} direction="vertical">
              <Step title="Basic Information" />
              <Step title="Select Group" />
            </Steps>
          </div>
        )}

        <div style={{ flex: 1, marginTop: 24 }}>
          <Form {...layout} {...formProps} style={{ maxWidth: 1100 }}>
            {formList[current]}
          </Form>

          {current === 2 && (
            <Result status="success" title="Successfully submitted">
              <Space direction="vertical" style={{ width: "100%" }}>
                <Button block size="large" onClick={handleOk}>
                  Okay
                </Button>
              </Space>
            </Result>
          )}

          {current === 3 && (
            <Result status="error" title="Error occurred, please try again.">
              <Space direction="vertical" style={{ width: "100%" }}>
                <Button block size="large" onClick={handleModal}>
                  Okay
                </Button>
              </Space>
            </Result>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default AddAgentModal;
